/**
 * Converts a locale string to a preferred language key.
 * Maps French locales (fr-CA, fr) to 'fr', all others to 'en'.
 *
 * @param locale - The locale string (e.g., 'en', 'fr-CA', 'fr')
 * @returns The language key ('fr' or 'en')
 */
export const getPreferredLanguageKey = (locale: string): 'fr' | 'en' => {
  return locale === 'fr-CA' || locale === 'fr' ? 'fr' : 'en';
};
